import axios from "axios";
import { environment } from "./env";
import { toast } from "react-toastify";
import { setLogin, setUserDetails } from "../Redux/Slice/LoginSlice";

let store

export const injectStore = _store => {
    store = _store;
}

const customAxios = axios.create({
    baseURL: environment.base_url
})

const requestHandler = (request) => {
    const userToken = localStorage.getItem('Token')
    request.headers.Authorization = `Bearer ${userToken}`;
    return request;
}

const responseHandler = (response) => {
    if (response.status === 401) {
        return response;
    }
    return response;
}

const errorHandler = (error) => {
    try {
        const logoutErrors = [
            'User token is not valid',
            'User token is expired',
            'Your company is delisted',
            'User is deListed',
            'User is deleted'
        ];
        if (logoutErrors.includes(error.response?.data?.error)) {
            toast.error(error.response?.data?.error);
            store.dispatch(setLogin(false));
            store.dispatch(setUserDetails([]));
            window.location.replace('/');
            return;
        }
    } catch (err) {
        console.error("Error handling failed:", err);
    }
    return Promise.reject(error);
}

customAxios.interceptors.request.use(
    (request) => requestHandler(request),
    (error) => errorHandler(error)
)

customAxios.interceptors.response.use(
    (response) => responseHandler(response),
    (error) => errorHandler(error)
);

export default customAxios;